import { Component, OnInit } from '@angular/core';
import { initFlowbite } from 'flowbite';
import { RouterOutlet } from '@angular/router';
import { SocketRouteManagerComponent } from './core/components/socket-route-manager.component';
import { LoaderComponent } from './shared/loader/loader.component';
import { VendorBidSocketToastService } from './core/service/vendor-bid-socket-toast.service';
import { VendorCounterOfferSocketToastService } from './core/service/vendor-counter-offer-socket-toast.service';
import { VendorEventExtendedSocketToastService } from './core/service/vendor-event-extended-socket-toast.service';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet, SocketRouteManagerComponent, LoaderComponent],
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
    /** Eagerly registers app-wide socket toasts (any route). */
    constructor(
        private readonly vendorBidSocketToastService: VendorBidSocketToastService,
        private readonly vendorCounterOfferSocketToastService: VendorCounterOfferSocketToastService,
        private readonly vendorEventExtendedSocketToastService: VendorEventExtendedSocketToastService,
    ) {}

    ngOnInit(): void {
        initFlowbite();
    }
}
